<template>
  <div id="app">
    <div class="header-spacer" :class="{ 'with-ad': showAd && advertisementList.length > 0 }"></div>
    <el-container>
      <el-header class="modern-header">
        <!-- 广告横幅区域 - 多条广告滚动 -->
        <div class="ad-banner" v-if="showAd && advertisementList.length > 0" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
          <div class="ad-scroll-container" ref="scrollContainer">
            <div class="ad-scroll-wrapper" :style="{ marginTop: `-${currentIndex * itemHeight}px` }">
              <div 
                class="ad-item" 
                v-for="(ad, index) in advertisementList" 
                :key="ad.id"
                :ref="`adItem${index}`"
                @click="goToAdUrl(ad)">
                <div class="ad-content">
                  <img :src="ad.logo_image" :alt="ad.name">
                  <div class="ad-text">
                    <i class="el-icon-star-on"></i>
                    <span>{{ ad.name }}</span>
                  </div>
                  <div class="ad-type" v-if="ad.type">
                    <span>{{ ad.type }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ad-close" @click.stop="closeAd">
            <i class="el-icon-close"></i>
          </div>
        </div>
        
        <div class="header-content">
          <div class="head-left">
            <router-link to="/" class="logo-link">
              <div class="logo-text">
                <h1>众包网</h1>
                <p class="site-subtitle">全国服务众包导航网站</p>
              </div>
            </router-link>
          </div>

          <div class="head-right">
            <p v-if="!isMobile" class="navigation-tip">众包导航·常看常新·收藏本站·Ctrl+D!</p>
            <p class="stats">已收录<span class="highlight">{{ webTotal }}</span>家平台，
              您是第<span class="highlight">{{ visits }}</span>位访客</p>
          </div>
        </div>
      </el-header>
      
      <el-main class="modern-main">
        <router-view />
      </el-main>

      <el-footer class="modern-footer">
        <div class="footer-content">
          <div class="footer-section">
            <div class="footer-links">
              <p class="section-title">其他链接</p>
              <div class="link-group">
                <a href="https://www.gov.cn/" target="_blank">中国政府网</a>
                <a href="https://www.miit.gov.cn/" target="_blank">工业和信息化部</a>
                <a href="https://www.ccopyright.com.cn/" target="_blank">中国版权保护中心</a>
              </div>
            </div>
            
            <div class="footer-actions">
              <div class="action-card" v-for="action in footerActions" :key="action.name">
                <router-link v-if="action.route" :to="action.route" class="action-link">
                  <div class="action-icon">
                    <img :src="action.icon" :alt="action.name">
                  </div>
                  <span>{{ action.name }}</span>
                </router-link>
              </div>
            </div>
          </div>
          
          <div class="footer-bottom">
            <p class="copyright">
              Copyright © 2026 
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                蜀ICP备2021027962号-5
              </a>
            </p>
            <!-- 公安备案 -->
            <div class="police-badge">
              <img :src="policeIcon" class="police-icon" />
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010802033117" target="_blank" rel="noopener noreferrer">
                川公网安备51010802033117号
              </a>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { webNum, getGgLb } from './api/all'
// 导入公安备案图标
import policeIcon from './assets/police.png'

export default {
  name: 'HomeView',
  data() {
    return {
      isMobile: null,
      webTotal: 0,
      visits: 0,
      advertisementList: [],
      showAd: true,
      currentIndex: 0,
      scrollTimer: null,
      isPaused: false,
      itemHeight: 52, // 每条广告的高度（px）
      policeIcon: policeIcon, // 公安备案图标
      footerActions: [
        { name: '收录申请', route: '/about', icon: '/home/slsq.png' },
        { name: '留言反馈', route: '/jyly', icon: '/home/jyly.png' }
      ]
    }
  },
  mounted() {
    this.getWebTotal()
    this.getAdvertisement()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    this.stopScroll()
  },
  methods: {
    getWebTotal() {
      webNum()
        .then(res => {
          this.webTotal = res.data[0]
          this.visits = res.data[1]
        })
        .catch(err => {
          console.error('获取统计数据失败:', err)
        })
    },
    async getAdvertisement() {
      try {
        const res = await getGgLb()
        if (res && res.status === 1 && res.data && res.data.length > 0) {
          const validAds = res.data.filter(ad => ad.logo_image && ad.network_addr)
          this.advertisementList = validAds
          
          if (this.advertisementList.length > 1) {
            this.$nextTick(() => {
              // 获取实际高度
              this.updateItemHeight()
              this.startScroll()
            })
          }
        }
      } catch (error) {
        console.error('获取广告失败:', error)
      }
    },
    updateItemHeight() {
      if (this.$refs.adItem0 && this.$refs.adItem0[0]) {
        const height = this.$refs.adItem0[0].offsetHeight
        if (height > 0) {
          this.itemHeight = height
          // 更新容器高度
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.style.height = `${this.itemHeight}px`
          }
        }
      }
    },
    goToAdUrl(ad) {
      if (ad && ad.network_addr) {
        window.open(ad.network_addr, '_blank')
      }
    },
    closeAd() {
      this.showAd = false
      this.stopScroll()
    },
    startScroll() {
      this.stopScroll()
      
      if (this.advertisementList.length <= 1) return
      
      this.scrollTimer = setInterval(() => {
        if (!this.isPaused && this.advertisementList.length > 1) {
          let nextIndex = this.currentIndex + 1
          if (nextIndex >= this.advertisementList.length) {
            nextIndex = 0
          }
          this.currentIndex = nextIndex
        }
      }, 3000)
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    pauseScroll() {
      this.isPaused = true
    },
    resumeScroll() {
      this.isPaused = false
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      // 移动端高度调整
      if (this.isMobile) {
        this.itemHeight = 44
      } else {
        this.itemHeight = 52
      }
      this.updateItemHeight()
    }
  },
  watch: {
    isMobile() {
      this.updateItemHeight()
    }
  }
}
</script>

<style lang="less" scoped>
:root {
  --primary: #3EA9F6;
  --primary-dark: #2A8ACF;
  --primary-light: #67C2FF;
  --secondary: #FF6F2C;
  --accent: #FFCB63;
  --text-dark: #2D3748;
  --text-light: #718096;
  --bg-light: #F7FAFC;
  --bg-white: #FFFFFF;
  --border-radius: 12px;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.07);
  --shadow-lg: 0 10px 15px rgba(0,0,0,0.1);
  --transition: all 0.3s ease;
}

#app {
  min-height: 100vh;
  background: var(--bg-light);
}

.header-spacer {
  height: 81px;
  width: 100%;
  
  &.with-ad {
    height: 125px;
  }
  
  @media (max-width: 768px) {
    height: 70px;
    
    &.with-ad {
      height: 108px;
    }
  }
}

.modern-header {
  height: auto !important;
  min-height: 81px;
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  box-shadow: var(--shadow-md);
  border-bottom: 1px solid rgba(255,255,255,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  
  .ad-banner {
    background: linear-gradient(135deg, #e8f0fe 0%, #f0f4f8 100%);
    border-bottom: 1px solid rgba(0,0,0,0.05);
    position: relative;
    overflow: hidden;
    animation: slideDown 0.5s ease-out;
    
    .ad-scroll-container {
      overflow: hidden;
      height: 52px;
      
      .ad-scroll-wrapper {
        transition: margin-top 0.5s ease-in-out;
        
        .ad-item {
          height: 52px;
          width: 100%;
          cursor: pointer;
          
          .ad-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 8px 60px 8px 20px;
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            
            img {
              height: 36px;
              width: auto;
              max-width: 160px;
              object-fit: contain;
              border-radius: 6px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            }
            
            .ad-text {
              display: flex;
              align-items: center;
              gap: 6px;
              color: #2c3e50;
              font-size: 13px;
              font-weight: 500;
              
              i {
                font-size: 14px;
                color: #e74c3c;
                animation: pulse 1.5s infinite;
              }
              
              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 300px;
              }
            }
            
            .ad-type {
              background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
              padding: 2px 8px;
              border-radius: 12px;
              margin-left: 4px;
              flex-shrink: 0;
              
              span {
                color: white;
                font-size: 11px;
                font-weight: 600;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    
    .ad-close {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.1);
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.3s ease;
      z-index: 10;
      
      &:hover {
        background: rgba(0,0,0,0.2);
        transform: translateY(-50%) scale(1.1);
      }
      
      i {
        color: #666;
        font-size: 12px;
      }
    }
  }
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 81px;
    padding: 0 20px;
  }
  
  .logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-2px);
    }
  }
  
  .logo-text {
    h1 {
      color: white;
      font-size: 28px;
      font-weight: 700;
      margin: 0;
      text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      line-height: 1.2;
    }
    
    .site-subtitle {
      color: rgba(255,255,255,0.9);
      font-size: 14px;
      margin: 2px 0 0 0;
      font-weight: 500;
    }
  }
  
  .navigation-tip {
    font-size: 14px;
    color: rgba(255,255,255,0.9);
    margin-bottom: 5px;
    margin: 0;
  }
  
  .stats {
    color: white;
    font-size: 14px;
    margin: 0;
    text-align: right;
  }
  
  .highlight {
    color: var(--accent);
    font-weight: bold;
    font-size: 16px;
    margin: 0 4px;
  }
}

.modern-main {
  padding: 0;
  min-height: calc(100vh - 180px);
}

.modern-footer {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  padding: 0;
  height: auto !important;
  
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px 20px;
  }
  
  .footer-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 30px;
    }
  }
  
  .footer-links {
    flex: 1;
    
    .section-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 15px;
      color: white;
    }
    
    .link-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      a {
        color: rgba(255,255,255,0.9);
        text-decoration: none;
        transition: var(--transition);
        font-size: 14px;
        
        &:hover {
          color: var(--accent);
          transform: translateX(5px);
        }
      }
    }
  }
  
  .footer-actions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    
    @media (max-width: 480px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }
  }
  
  .action-card {
    text-align: center;
    
    .action-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
      color: white;
      transition: var(--transition);
      cursor: pointer;
      
      &:hover {
        transform: translateY(-5px);
        
        .action-icon {
          background: rgba(255,255,255,0.2);
          transform: scale(1.1);
        }
      }
    }
    
    .action-icon {
      width: 60px;
      height: 60px;
      background: rgba(255,255,255,0.1);
      border-radius: var(--border-radius);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      transition: var(--transition);
      backdrop-filter: blur(10px);
      
      img {
        width: 35px;
        height: 35px;
      }
    }
    
    span {
      font-size: 14px;
      font-weight: 500;
      color: white;
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.2);
    padding-top: 20px;
    text-align: center;
    
    .copyright {
      margin: 0 0 12px 0;
      color: rgba(255,255,255,0.9);
      font-size: 14px;
      
      a {
        color: var(--accent);
        text-decoration: none;
        
        &:hover {
          color: white;
          text-decoration: underline;
        }
      }
    }
    
    .police-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      
      .police-icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }
      
      a {
        color: rgba(255,255,255,0.8);
        text-decoration: none;
        font-size: 12px;
        transition: var(--transition);
        
        &:hover {
          color: var(--accent);
          text-decoration: underline;
        }
      }
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@media screen and (max-width: 768px) {
  .modern-header {
    min-height: 70px;
    
    .ad-banner {
      .ad-scroll-container {
        height: 44px;
        
        .ad-scroll-wrapper .ad-item {
          height: 44px;
          
          .ad-content {
            padding: 6px 50px 6px 15px;
            
            img {
              height: 28px;
              max-width: 100px;
            }
            
            .ad-text {
              font-size: 11px;
              
              i {
                font-size: 11px;
              }
              
              span {
                max-width: 150px;
              }
            }
            
            .ad-type {
              padding: 1px 6px;
              
              span {
                font-size: 9px;
              }
            }
          }
        }
      }
      
      .ad-close {
        right: 15px;
        width: 22px;
        height: 22px;
        
        i {
          font-size: 11px;
        }
      }
    }
    
    .header-content {
      height: 70px;
      padding: 0 15px;
    }
    
    .logo-text {
      h1 {
        font-size: 20px;
      }
      
      .site-subtitle {
        font-size: 12px;
      }
    }
    
    .stats {
      font-size: 12px;
    }
    
    .highlight {
      font-size: 14px;
    }
    
    .navigation-tip {
      display: none;
    }
  }
  
  .modern-footer {
    .footer-content {
      padding: 30px 15px 15px;
    }
    
    .action-card .action-icon {
      width: 50px;
      height: 50px;
      
      img {
        width: 25px;
        height: 25px;
      }
    }
    
    .footer-bottom {
      .police-badge {
        .police-icon {
          width: 18px;
          height: 18px;
        }
        
        a {
          font-size: 11px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .modern-header {
    .ad-banner .ad-content {
      .ad-text span {
        max-width: 100px;
      }
      
      .ad-type {
        display: none;
      }
    }
    
    .logo-text {
      h1 {
        font-size: 18px;
      }
    }
  }
  
  .modern-footer {
    .footer-bottom {
      .police-badge {
        flex-wrap: wrap;
      }
    }
  }
}
</style>